import React, { useEffect, useState, useCallback } from "react";
import { fetchHcfDetails } from "./api";
import { ShowError } from "../../../components/error";
import { Title } from "./title";
import { Value } from "./value";
import { Stack } from "@mui/material";
import { showErrorToast } from "@src/appV2/lib/Notifications";
import { handleApiError } from "src/utils/errors";

function SentHomeChargeHours({ hcfId, updateFacility }) {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [details, setDetails] = useState<any>();
  const [error, setError] = useState();

  useEffect(() => {
    fetchHcfDetails(hcfId, "sentHomeChargeHours").then(setDetails).catch(setError);
  }, [hcfId]);

  const handleChange = useCallback(
    (data) => {
      if (data && data?.sentHomeChargeHours > 100) {
        showErrorToast("Sent Home Charge value should not be greater than 99");
      } else {
        updateFacility({
          ...data,
          facilityId: hcfId,
        }).catch(handleApiError);
      }
    },
    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [hcfId]
  );

  return (
    <Stack>
      <Title>Shift Sent Home Charge</Title>
      <ShowError error={error} message="Unable to fetch workplace Sent Home Charge" />
      <p className="content">
        Shifts where the workplace approved the worker to be sent home will be billed for
        <Value
          name="sentHomeChargeHours"
          onChange={handleChange}
          value={details?.sentHomeChargeHours}
        />
        hrs at the Workplace Total Charge.
      </p>
    </Stack>
  );
}

export { SentHomeChargeHours };
